import React from 'react';
import TickIcon from '@atlaskit/icon/utility/migration/check-mark--check';
import { TickBoxWrapper } from './tickBoxWrapper';
export var TickBox = function TickBox(_ref) {
  var selected = _ref.selected;
  return /*#__PURE__*/React.createElement(TickBoxWrapper, {
    selected: selected
  }, /*#__PURE__*/React.createElement(TickIcon, {
    color: "currentColor",
    label: "tick"
  }));
};